import styles from './Styles.module.scss'
import React from 'react'

export const Success = () => {
  const isIpOrAck = process.env.REACT_APP_IS_IP_OR_ACK === 'true'

  const url = window.location.href
  const urlOrgin = new URL(url).origin

  const finsovetnik =
    urlOrgin === process.env.REACT_APP_PROD_FA_URL ||
    urlOrgin === process.env.REACT_APP_TEST_FA_URL

  return (
    <div className={styles.root} data-testid="root">
      {isIpOrAck ? null : finsovetnik ? (
        <img
          data-testid="fs-logo"
          src="/FSlogo.png"
          alt=""
          className={styles.FSlogo}
        />
      ) : (
        <img
          data-testid="default-logo"
          src="/logo.png"
          alt=""
          className={styles.logo}
        />
      )}

      <div className={styles.sucMain} data-testid="sucMain">
        <img
          data-testid="successImg"
          src="/successImg.png"
          alt="successImg"
          className={styles.successImg}
        />

        <div className={styles.title} data-testid="title">
          Спасибо! Ваш заказ оплачен
        </div>
        <div className={styles.text} data-testid="text">
          Письмо подтверждение отправлено на электронную почту. Если вы не
          получили письма,{' '}
          <a
            data-testid="support-link"
            href="https://t.me/profinansy_help_bot"
            className={styles.supportText}
          >
            свяжитесь с нами
          </a>
        </div>
      </div>
    </div>
  )
}
